import { PageContext } from "@providers/page";
import { useContext } from "react";

const usePageData = () => {
  const { pageData } = useContext(PageContext);
  return pageData;
};

export default usePageData;
